import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../../../styles'

export const ResultCenteredRow = styled.div<{ height?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 30px;
  gap: 10px;
  height: ${({ height }) => (height ? `${height}%` : 'auto')};
  text-align: center;
  @media ${MEDIA_QUERY.MOBILE} {
    height: auto;
  }
`
